var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { ButtonHeader, CertificateTable, CertificatesTableContainer, DateText, } from "./subcomponents";
var CertificateHistoryTable = function (_a) {
    var certificates = _a.certificates;
    var t = useTranslation().t;
    var headers = [
        {
            value: (_jsx(ButtonHeader, __assign({ className: "sortable-header", buttonType: "text" }, { children: _jsx(DateText, { children: t("certificateHistoryTab.date") }) }))),
        },
        {
            value: (_jsx(DateText, { children: t("certificateHistoryTab.certificateNumber") })),
        },
        {
            value: _jsx(DateText, { children: t("certificateHistoryTab.status") }),
            align: "left",
        },
        _jsx(ButtonHeader, __assign({ className: "sortable-header", buttonType: "text" }, { children: _jsx(DateText, { children: t("certificateHistoryTab.amount") }) })),
    ];
    var tableData = __spreadArray([headers], certificates, true);
    return (_jsx(CertificatesTableContainer, { children: _jsx(CertificateTable, { tableData: tableData }) }));
};
export default CertificateHistoryTable;
